import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet'
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import { useForm, Controller } from "react-hook-form/dist/index.ie11";
import {
  useGoogleReCaptcha
} from 'react-google-recaptcha-v3';

import * as UIActions from '../../actions/uiAction';
import * as UserActions from '../../actions/userAction'

const Signup = ({ userRegister, history }) => {
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  const { register, handleSubmit, getValues, trigger, errors, control } = useForm({ mode: 'onChange' });
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [token, setToken] = useState(null);

  const onSubmit = async ({ email, password, firstName, lastName, type }) => {
    const success = await userRegister({ input: { recaptcha: token, email, password, firstName, lastName, type } })
    if (success) history.push('/login')
  }

  const validateCaptcha = async () => {
    setToken(await executeRecaptcha('signup_page'))
  }

  useEffect(() => {
    validateCaptcha()
  }, [])

  return (
    <Fragment>
      <Helmet>
        <title>QBank Sign Up Page</title>
        <meta name="description" content="QBank Sign Up Page allowed new user to create an QBank account and the benific to be a QBank user." />
      </Helmet>
      <div className="signupPage">
        <div className="qbCard">
          <div className="fTitle">SIGN UP</div>
          <div className="fBody">HAVE AN ACCOUNT? <span className="fLink" onClick={() => this.props.history.push('/login')}>LOGIN</span></div>
          <form className="qbForm" onSubmit={handleSubmit(onSubmit)}>
            <div className="itemCont">
              <TextField
                inputRef={register({ required: "Please enter first name" })}
                id="firstName"
                name="firstName"
                label="First Name"
                error={!!errors.firstName}
                helperText={errors.firstName && errors.firstName.message}
                required
                fullWidth
                InputProps={{
                  style: { fontSize: 15 }
                }}
                InputLabelProps={{
                  style: { fontSize: 15, color: 'rgba(0, 0, 0, 0.25)' }
                }}
                FormHelperTextProps={{
                  style: { fontSize: 13 }
                }}
              />
            </div>
            <div className="itemCont">
              <TextField
                inputRef={register({ required: "Please enter last name" })}
                id="lastName"
                name="lastName"
                label="Last Name"
                error={!!errors.lastName}
                helperText={errors.lastName && errors.lastName.message}
                required
                fullWidth
                InputProps={{
                  style: { fontSize: 15 }
                }}
                InputLabelProps={{
                  style: { fontSize: 15, color: 'rgba(0, 0, 0, 0.25)' }
                }}
                FormHelperTextProps={{
                  style: { fontSize: 13 }
                }}
              />
            </div>
            <div className="itemCont">
              <TextField
                inputRef={register({ required: "Please enter email", pattern: { value: emailRegex, message: "Invalid Email Format" } })}
                id="email"
                name="email"
                label="Email"
                error={!!errors.email}
                helperText={errors.email && errors.email.message}
                required
                fullWidth
                InputProps={{
                  style: { fontSize: 15 }
                }}
                InputLabelProps={{
                  style: { fontSize: 15, color: 'rgba(0, 0, 0, 0.25)' }
                }}
                FormHelperTextProps={{
                  style: { fontSize: 13 }
                }}
              />
            </div>
            <div className="itemCont">
              <TextField
                inputRef={register({ required: "Please enter password", minLength: { value: 6, message: "Password must be longer" } })}
                id="password"
                name="password"
                type="password"
                label="Password"
                error={!!errors.password}
                helperText={errors.password && errors.password.message}
                required
                fullWidth
                InputProps={{
                  style: { fontSize: 15 }
                }}
                InputLabelProps={{
                  style: { fontSize: 15, color: 'rgba(0, 0, 0, 0.25)' }
                }}
                FormHelperTextProps={{
                  style: { fontSize: 13 }
                }}
                onChange={() => trigger('password2')}
              />
            </div>
            <div className="itemCont">
              <TextField
                inputRef={register({ required: "Please enter confirm password", validate: (value) => value === getValues()['password'] || "Confirm password does not match with password" })}
                id="password2"
                type="password"
                name="password2"
                label="Confirm Password"
                error={!!errors.password2}
                helperText={errors.password2 && errors.password2.message}
                required
                fullWidth
                InputProps={{
                  style: { fontSize: 15 }
                }}
                InputLabelProps={{
                  style: { fontSize: 15, color: 'rgba(0, 0, 0, 0.25)' }
                }}
                FormHelperTextProps={{
                  style: { fontSize: 13 }
                }}
              />
            </div>
            <div className="itemCont">
              <FormControl fullWidth error={!!errors.type}>
                <InputLabel style={{ fontSize: 15, color: 'rgba(0, 0, 0, 0.25)' }}>
                  Type
                </InputLabel>
                <Controller
                  as={
                    <Select
                      SelectDisplayProps={{ style: { fontSize: 15 } }}
                    >
                      <MenuItem
                        value="student"
                        style={{ fontSize: 15 }}
                      >
                        Student
                      </MenuItem>
                      <MenuItem
                        value="aspirant"
                        style={{ fontSize: 15 }}
                      >
                        Aspirant
                      </MenuItem>
                      <MenuItem
                        value="learner"
                        style={{ fontSize: 15 }}
                      >
                        Learner
                      </MenuItem>
                    </Select>
                  }
                  name="type"
                  control={control}
                  rules={{ required: "Please choose at least one" }}
                />
                <FormHelperText style={{ fontSize: 13 }}>{!!errors.type && errors.type.message}</FormHelperText>
              </FormControl>
            </div>
            <div className="tncCont">By clicking "Sign Up", I agree to Kaplan's <span className="fLink">terms and conditions</span> and<br /><span className="fLink">privacy policy</span></div>
            <div className="actionCont">
              <button className={"qbBtn active"} type="submit">SIGN UP</button>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({ }) => ({
});

const mapDispatchToProps = (dispatch) => ({
  addError: (msg) => dispatch(UIActions.addError(msg)),
  showSuccess: (msg) => dispatch(UIActions.showSuccess(msg)),
  userRegister: (body) => dispatch(UserActions.register(body)),
  updateNavToCart: (type) => dispatch(UIActions.updateNavToCart(type))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Signup));



// WEBPACK FOOTER //
// ./src/Components/signup/Signup.js